import React from 'react';
import { useLocation } from 'react-router';
import { Accordion } from '@naf-simba/elements-accordion';
import useSelector from '@redux/typedHooks';
import { AccordionListBlockType } from '@appTypes/AccordionListBlockType';
import { useGTMDataLayer } from '@hooks/GTM/useGTMDataLayer';
import { NAFGTMEvent } from '@appTypes/GTM/NAFGTMEvent';
import { EventPayload } from '@appTypes/GTM/EventPayload';
import BlockContent from '../../../BlockContent';

export interface AccordionListBlockSerializerProps {
  value: AccordionListBlockType;
}

export const AccordionListBlock = ({ value }: AccordionListBlockSerializerProps) => {
  const location = useLocation();
  const dataLayer = useGTMDataLayer();
  const baseUrl = useSelector((state) => state.application.baseUrl);

  const onOpen = (accordionTitle: string) => {
    if (dataLayer) {
      const eventPayload: EventPayload = {
        event: NAFGTMEvent.accordionOpen,
        listValue: `${accordionTitle}`,
        page: location.pathname,
        pageUrl: `${baseUrl}${location.pathname}`,
      };
      dataLayer.push(eventPayload);
    }
  };

  return (
    <>
      {value.accordionList.map((item) => (
        <Accordion
          headingLevel={3}
          key={item._key}
          title={item.title}
          onChange={({ value: isOpen }) => isOpen && onOpen(item.title)}
        >
          <BlockContent value={item.content} />
        </Accordion>
      ))}
    </>
  );
};
